import { render, staticRenderFns } from "./LayoutAdminBar.vue?vue&type=template&id=ecb6edd2&scoped=true&"
import script from "./LayoutAdminBar.vue?vue&type=script&lang=js&"
export * from "./LayoutAdminBar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAdminBar.vue?vue&type=style&index=0&id=ecb6edd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb6edd2",
  null
  
)

export default component.exports